import React from 'react';
import { Label, } from 'components'
import { formatVerificationStatus, } from 'helpers/helpers'
import PropTypes from 'prop-types'
import {
  colors,
} from '@material-ui/core'
import { NOT_VERIFIED, VERIFIED, IN_PROCESS, REJECTED, ASKED_VERIFICATION, VERIFIED_MESSAGE_SHOWN, } from 'constants/userValidationStatus'

const VerificationStatus = (props) => {
  const { status, } = props

  const statusColors = {
    [NOT_VERIFIED]: colors.red[600],
    [REJECTED]: colors.red[600],
    [ASKED_VERIFICATION]: colors.orange[600],
    [IN_PROCESS]: colors.orange[600],
    [VERIFIED]: colors.green[600],
    [VERIFIED_MESSAGE_SHOWN]: colors.green[600],
  }

  return typeof status !== 'undefined' && (
    <Label
      color={statusColors[status]}
      variant="outlined"
    >
      {formatVerificationStatus(status)}
    </Label>
  )
}

VerificationStatus.propTypes = {
  status: PropTypes.number,
};

export default VerificationStatus
